export default "__VITE_ASSET__D449txRr__"